import { createPerson, createPersonMock } from 'utils/personUtils';
import { createOrg, createOrgMock } from 'utils/orgUtils';
import { GiroPayment } from 'types/state';
import { createRandomBoolean } from 'utils/randomBooleanUtils';
import { createUniqueRuntimeNumber } from 'utils/uniqueRuntimeNumberUtils';
import {
  createBankAccount,
  createBankAccountMock,
} from 'utils/bankAccountUtils';
import {
  createPaymentTransaction,
  createPaymentTransactionBYNMock,
  createPaymentTransactionUSDMock,
} from 'utils/paymentUtils';
import { createM8RateDTOMock } from 'utils/m8RateDTOUtils';

export const createGiroPayment = (): GiroPayment => ({
  id: 0,
  from: createBankAccount(''),
  creditedTransaction: createPaymentTransaction(),
  recievedTransaction: createPaymentTransaction(),
  exchangeRate: null,
  comment: '',
  updatedAt: new Date().toISOString(),
  createdAt: new Date().toISOString(),
  clientId: 0,
  person: createPerson(),
  org: createOrg(),
  status: 'CLIENT_NOT_FOUND',
  recievedAt: new Date().toISOString(),
});

export const createGiroPaymentMock = (id: number): GiroPayment => ({
  id,
  from: createBankAccountMock(),
  creditedTransaction: createPaymentTransactionUSDMock(),
  recievedTransaction: createPaymentTransactionBYNMock(),
  exchangeRate: createM8RateDTOMock(),
  comment: 'На все хорошее против всего плохого.',
  updatedAt: new Date().toISOString(),
  createdAt: new Date().toISOString(),
  clientId: createUniqueRuntimeNumber(),
  person: createPersonMock(),
  org: createOrgMock(),
  status: createRandomBoolean()
    ? 'CLIENT_FOUND'
    : createRandomBoolean()
    ? 'CLIENT_NOT_FOUND'
    : createRandomBoolean()
    ? 'FAILED'
    : 'OK',
  recievedAt: new Date().toISOString(),
});
